import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './Badge.module.scss';

export type BadgeProps = {
  className?: string;
  children?: ReactNode;
  color?: 'grey' | 'green' | 'yellow' | 'black' | 'red' | 'white';
  variant?: 'default' | 'pill';
  size?: 'small' | 'medium' | 'large';
};

export const Badge = ({
  children,
  className,
  color = 'grey',
  variant = 'default',
  size = 'medium',
  ...props
}: BadgeProps) => (
  <span
    className={classNames(styles.root, styles[color], styles[variant], styles[size], className)}
    {...props}>
    {children}
  </span>
);
